// File: frontend/src/routes/PublicRoute.js

import React from 'react';

const PublicRoute = ({ children }) => {
  return children;
};

export default PublicRoute;
